import { useEffect, useState } from "react";
import { toast } from "sonner";
import { Dialog, DialogContent, DialogFooter, DialogHeader, DialogTitle } from "@/components/ui/dialog";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Field, NativeSelect, Segmented } from "@/components/common";
import { api, errMsg, todayStr, qty } from "@/lib/api";

export default function StockDialog({ open, onOpenChange, product, products, onSaved }) {
  const [f, setF] = useState({});
  const [busy, setBusy] = useState(false);
  useEffect(() => {
    if (open) setF({ product_id: product?.id || "", type: "in", qty: "", date: todayStr(), description: "" });
  }, [open, product]);
  const set = (k) => (e) => setF({ ...f, [k]: e.target.value });
  const sel = product || products?.find((p) => p.id === f.product_id);

  const save = async (e) => {
    e.preventDefault();
    if (!f.product_id) return toast.error("Ürün seçin");
    setBusy(true);
    try {
      await api.post("/stock/adjust", { ...f, qty: Number(f.qty) });
      toast.success("Stok hareketi kaydedildi");
      onOpenChange(false);
      onSaved?.();
    } catch (e2) {
      toast.error(errMsg(e2));
    }
    setBusy(false);
  };

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="max-w-md rounded-[4px]" data-testid="stock-dialog">
        <DialogHeader><DialogTitle className="font-display text-xl">Manuel Stok Hareketi</DialogTitle></DialogHeader>
        <form onSubmit={save} className="space-y-4">
          <Segmented value={f.type} onChange={(v) => setF({ ...f, type: v })} prefix="stock-type" options={[["in", "Stok Girişi"], ["out", "Stok Çıkışı"]]} />
          {!product && (
            <Field label="Ürün">
              <NativeSelect value={f.product_id} onChange={set("product_id")} data-testid="stock-product-select">
                <option value="">Seçin…</option>
                {products?.map((p) => <option key={p.id} value={p.id}>{p.code} · {p.name}</option>)}
              </NativeSelect>
            </Field>
          )}
          {sel && <div className="text-xs text-muted-foreground">Mevcut stok: <b className="font-num">{qty(sel.stock)} {sel.unit}</b></div>}
          <div className="grid grid-cols-2 gap-4">
            <Field label="Miktar"><Input required type="number" step="any" min="0" value={f.qty} onChange={set("qty")} data-testid="stock-qty-input" /></Field>
            <Field label="Tarih"><Input required type="date" value={f.date} onChange={set("date")} data-testid="stock-date-input" /></Field>
          </div>
          <Field label="Açıklama"><Input value={f.description} onChange={set("description")} placeholder="Sayım farkı, fire vb." data-testid="stock-desc-input" /></Field>
          <DialogFooter>
            <Button type="button" variant="outline" onClick={() => onOpenChange(false)} data-testid="stock-cancel-button">Vazgeç</Button>
            <Button type="submit" disabled={busy} data-testid="stock-save-button">Kaydet</Button>
          </DialogFooter>
        </form>
      </DialogContent>
    </Dialog>
  );
}
